import { useQuery } from 'react-query'

import { customFieldQueryConfig } from '@webapp/core/query-configs/customField'

/**
 * Every line-item custom field in one page, for a select. No
 * `meta__is_active` filter is sent, so fields that are no longer active are
 * included — a budget may still be scoped to one.
 */
export const useQueryAllOrderItemCustomFields = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  const { data, isLoading, isFetching, isError, error } = useQuery({
    ...customFieldQueryConfig.getAllOrderItemCustomFields(),
    enabled,
  })

  return {
    customFields: data ?? [],
    isLoading: isLoading && !data,
    isFetching,
    isError,
    error,
  }
}
